// src/pages/ContractStatus.js
import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import TabContext from "@/contexts/TabContext";
import { contractStatusOptions } from "@/constants/selectOptions";
import { useListPageFilter, dateFormatToISOString, dateFormatDateTime, comma } from "@/utils";
import { PageTabs, Pagination, Toast, Confirm } from "@/components";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import Select from "react-select";
import { orderTypeOptions, displacementOptions } from "@/constants/selectOptions";

import { useGetContractGroupListQuery } from "@/redux/contractApi";
import { Loading } from "../../components";
import {formatPhoneNumber} from "../../utils";

// 페이지 기본 필터
const pageFilter = {
    parameters: {
        page: 0,
        size: 20,
        query: "",
        contract_status_in: "",
        online_sign_yn: "N"
    },
};

export const OnlineContractStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state: tabs, dispatch } = useContext(TabContext);

    // 탭(토글) 상태: "create" / "signature"
    const [currentTab, setCurrentTab] = useState("create");

    // formData에 pageFilter와 팝업/토스트 상태 등을 넣음
    const { formData, handleChange, setFormData, parameters, toastMsg } = useListPageFilter(pageFilter, {
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        orderDetailPopupStatus: false,
        signLinkGuidePopupStatus: false,
        contractRegisterGuidePopupStatus: false,
        triggerSearch: false,
    });

    const { confirmStatus, orderDetailPopupStatus, signLinkGuidePopupStatus, contractRegisterGuidePopupStatus, triggerSearch } = formData;

    // 탭 추가 로직 (VehicleGarage 예시와 동일)
    useEffect(() => {
        const handleTabAdd = () => {
            const existingTab = tabs.find((tab) => tab.url.split("?")[0] === location.pathname);
            if (!existingTab) {
                dispatch({
                    type: "ADD_TAB",
                    payload: { url: location.pathname + location.search, title: "비대면 계약서" },
                });
            }
        };
        handleTabAdd();
    }, [dispatch, location.pathname, location.search, tabs]);

    // 컴포넌트 마운트 시 초기 데이터 조회
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            triggerSearch: true,
        }));
    }, []);

    const { data: createData, error: errorCreate } = useGetContractGroupListQuery(parameters, {
        skip: currentTab !== "create" || !triggerSearch,
        refetchOnMountOrArgChange: true,
    });

    const signatureParams = {
        ...parameters,
        contract_status_in: "SEND_FINISH,SIGN_FINISH",
    };

    const { data: signatureData, error: errorSignature } = useGetContractGroupListQuery(signatureParams, {
        skip: currentTab !== "signature" || !triggerSearch,
        refetchOnMountOrArgChange: true,
    });

    // 아래처럼 데이터/로딩/에러를 분기 처리
    const data = currentTab === "create" ? createData : signatureData;
    const error = currentTab === "create" ? errorCreate : errorSignature;

    // 검색 버튼 클릭
    const handleSearch = () => {
        setFormData((prev) => ({
            ...prev,
            parameters: { ...prev.parameters, page: 0 },
            triggerSearch: true,
        }));
    };

    // 삭제 버튼
    const handleDelete = () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: "서명 요청 취소",
                confirmDescription: "해당 계약서를 삭제 하시겠습니까?",
                confirmButtons: [
                    { label: "예", className: "btn-primary", onClick: console.log("삭제") },
                    {
                        label: "아니오",
                        className: "btn-cancel",
                        onClick: () =>
                            setFormData((prev2) => ({
                                ...prev2,
                                confirmStatus: { confirmPopupStatus: false },
                            })),
                    },
                ],
            },
        }));
    };

    useEffect(() => {
        console.log(data);
    }, [data]);

    return (
        <>
            <div className="management container">
                <PageTabs />

                <div className="table-container">
                    <div className="table-head">
                        <span className="head-tit">비대면 계약서 현황</span>
                        <div className="breadcrumbs">
                            <ul>
                                <li className="home"></li>
                                <li>임대차 계약서</li>
                                <li>비대면 계약서 현황</li>
                            </ul>
                        </div>
                    </div>
                    <TableFilter formData={formData} handleChange={handleChange} setFormData={setFormData} handleSearch={handleSearch} />

                    <div className="table-content">
                        <div className="table-option">
                            <div className="table-caption">
                                {/* <div className="toggle-list">
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === "create" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("create")}
                                    >
                                        작성 목록
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn-toggle ${currentTab === "signature" ? "active" : ""}`}
                                        onClick={() => setCurrentTab("signature")}
                                    >
                                        서명 요청
                                    </button>
                                </div> */}
                                <span className="data-count">
                                    전체 <b>{data?.pagination?.totalElements}</b>건{" "}
                                </span>
                            </div>
                            <div className="table-buttons">

                            </div>
                        </div>

                        <div className="table-wrapper">
                            <div className="table">
                                {/* currentTab === 'create' */}
                                {currentTab === "create" && (
                                    <table>
                                        <colgroup>
                                            <col width="7%"/>
                                            <col width="7%"/>
                                            <col width="7%"/>
                                            <col width="7%"/>
                                            <col width="7%"/>
                                            <col width="6%"/>
                                            <col width="7%"/>
                                            <col width="6%"/>
                                            <col width="6%"/>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">계약번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">계약유형</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">등록일</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차량번호</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">차량정보</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">고객명</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">연락처</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">작성자</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div className="cell">
                                                    <span className="cell-tit">상태</span>
                                                </div>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data && data.data && data.data.length > 0 ? (
                                            data.data.map((item, index) => {
                                                const contracts = item.contracts || [];
                                                    const firstContract = contracts[0];
                                                    const additionalCount = contracts.length > 1 ? contracts.length - 1 : 0;

                                                    return (
                                                        <tr key={index} className={item.orderId ? "call-contract" : ""}>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className="cell-desc">{item.serialNumber}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className={`cell-tag tag-box ${
                                                                            orderTypeOptions.find(
                                                                                (option) => option.value === item?.contractType
                                                                            )?.tagColor || ""
                                                                        }`}
                                                                    >
                                                                        {orderTypeOptions.find(
                                                                            (option) => option.value === item?.contractType
                                                                        )?.label || "미확정"}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {dateFormatDateTime(item?.createdAt, "YYYY-MM-DD HH:mm")}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span className="cell-desc">
                                                                        {firstContract?.contractCar?.carNumber}
                                                                        {additionalCount > 0 && ` 외 ${additionalCount}대`}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="left">
                                                                    <span className="cell-desc">
                                                                        {firstContract?.contractCar?.modelDetailName}
                                                                        {additionalCount > 0 && ` 외 ${additionalCount}대`}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className="cell-desc">{item?.customerName}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className="cell-desc">{formatPhoneNumber(item?.customerPhone || "")}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    <span
                                                                        className="cell-tag">{item?.writer?.name}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="cell" data-align="center">
                                                                    {(() => {
                                                                        const status = contractStatusOptions.find(
                                                                            (e) => e.value === item?.contractStatus
                                                                        );
                                                                        return (
                                                                            <span
                                                                                className={`cell-tag ${status?.txtColor || ""}`}>
                                                                            {status?.label ?? "-"}
                                                                        </span>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="10" className="data-empty">
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc">데이터가 없습니다.</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>

                        {data && data.pagination && data.data && data.data.length > 0 && (
                            <Pagination pagination={data.pagination} setFormData={setFormData}/>
                        )}
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus?.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {orderDetailPopupStatus && (
                <OrderDetailPopup
                    popupStatus={orderDetailPopupStatus}
                    layer={false}
                    onClose={() => setFormData((prev) => ({ ...prev, orderDetailPopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}

            {signLinkGuidePopupStatus && (
                <SignLinkGuidePopup
                    popupStatus={signLinkGuidePopupStatus}
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, signLinkGuidePopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}

            {contractRegisterGuidePopupStatus && (
                <ContractRegisterGuidePopup
                    popupStatus={contractRegisterGuidePopupStatus}
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, contractRegisterGuidePopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

const TableFilter = ({ formData, setFormData, handleSearch }) => {
    const [filterOption, setFilterOption] = useState([]);
    const [clientLabel, setClientLabel] = useState({});
    const [statusLabel, setStatusLabel] = useState();

    const { parameters } = formData;
    const [activeButton, setActiveButton] = useState(null);

    // const { data, error, isLoading } = useGetClientNameListQuery();

    // useEffect(() => {
    //     if (data?.data) {
    //         var res = [{ value: null, label: "전체" }];
    //         data?.data?.forEach((i) => {
    //             res.push({ value: i.id, label: i.clientCorName });
    //         });
    //         setFilterOption(res);
    //     }
    // }, [data]);

    const handleParameterChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                [name]: value,
            },
            triggerSearch: false,
        }));
    };

    const handleDateChange = (dates, type) => {
        const [start, end] = dates;

        if (type === "create") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    started_at: start ? dateFormatToISOString(start, "start") : "",
                    ended_at: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        if (type === "service") {
            setFormData((prev) => ({
                ...prev,
                parameters: {
                    ...prev.parameters,
                    reserveDateStart: start ? dateFormatToISOString(start, "start") : "",
                    reserveDateEnd: end ? dateFormatToISOString(end, "end") : "",
                },
                triggerSearch: false,
            }));
        }

        setActiveButton(null);
    };

    const setDateRange = (days, buttonIndex) => {
        const now = new Date();
        const start = new Date(now);
        start.setDate(start.getDate() - days);

        setFormData((prev) => ({
            ...prev,
            parameters: {
                ...prev.parameters,
                page: 0,
                started_at: dateFormatToISOString(start, "start"),
                ended_at: dateFormatToISOString(now, "end"),
            },
            triggerSearch: false,
        }));

        setActiveButton(buttonIndex);
    };

    return (
        <div className="table-filter">
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">계약 상태 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-select" style={{ width: "auto" }}>
                            <Select
                                options={contractStatusOptions}
                                className="filter-select width-auto"
                                classNamePrefix="filter-select"
                                isSearchable={false}
                                isMulti
                                placeholder="진행현황 선택"
                                value={statusLabel}
                                onChange={(selectedOptions) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        parameters: {
                                            ...prev.parameters,
                                            contract_status_in: selectedOptions.map((option) => option.value).join(","),
                                        },
                                    }));
                                    setStatusLabel(selectedOptions);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-head">
                        <span className="head-tit">등록일 :</span>
                    </div>
                    <div className="item-content">
                        <div className="item-input">
                            <DatePicker
                                locale={ko}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={20}
                                dateFormat="yyyy.MM.dd"
                                onKeyDown={(e) => e.preventDefault()}
                                selectsRange={true}
                                startDate={parameters.started_at ? new Date(parameters.started_at) : null}
                                endDate={parameters.ended_at ? new Date(parameters.ended_at) : null}
                                onChange={(e) => handleDateChange(e, "create")}
                            />
                        </div>
                    </div>
                </div>
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-buttons">
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 0 ? "active" : ""}`}
                                onClick={() => setDateRange(0, 0)}
                            >
                                당일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 15 ? "active" : ""}`}
                                onClick={() => setDateRange(15, 15)}
                            >
                                15일
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 30 ? "active" : ""}`}
                                onClick={() => setDateRange(30, 30)}
                            >
                                1개월
                            </button>
                            <button
                                type="button"
                                className={`btn-toggle ${activeButton === 90 ? "active" : ""}`}
                                onClick={() => setDateRange(90, 90)}
                            >
                                3개월
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filter-row">
                <div className="filter-item">
                    <div className="item-content">
                        <div className="item-input" style={{ width: "300px" }}>
                            <input
                                type="text"
                                placeholder="입력하세요."
                                name="query"
                                value={parameters.query}
                                onChange={handleParameterChange}
                            />
                        </div>
                        <div className="item-buttons">
                            <button type="button" className="btn-search" onClick={handleSearch}>
                                검색
                            </button>
                            <button
                                type="button"
                                className="btn-search"
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ...pageFilter,
                                    }));
                                    setClientLabel({ value: null, label: "전체" });
                                }}
                            >
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 차량 일괄 등록 팝업
const OrderDetailPopup = ({ popupStatus, layer = true, onClose, formData, setFormData }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (popupStatus) {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 10);
            return () => clearTimeout(timer);
        }
    }, [popupStatus]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => {
            onClose();
        }, 200);
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleConfirm = () => {
        navigate(`/vehicle/manage/register/excel`);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={handleClose}></div>

            <div className={`popup popup-side order-detail-popup ${isVisible ? "active" : ""}`}>
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">실시간 오더 상세</span>
                    </div>
                    <div className="btn-close" onClick={handleClose}></div>
                </div>
                <div className="popup-content">
                    <div className="order-detail-info">
                        <div className="info-content">
                            <div className="detail-summary">
                                <div className="summary-info">
                                    <span className="insurance-type">보험대차</span>
                                    <span className="insurance-num">250125101001</span>
                                </div>
                                <div className="order-status">매칭전</div>
                            </div>
                            <div className="detail-info">
                                <div className="info-item">
                                    <div className="item-desc">경기도 하남시 / 만 26세 이상</div>
                                    <div className="item-date">2025.02.06(목) 19:32</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="side_item-container">
                        <div className="side_item-wrapper">
                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">오더 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">요청구분</span>
                                        <span className="item-desc">보험대차</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">차량정보</span>
                                        <span className="item-desc">K8 GL3 하이브리드 노블레스</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">이용지역</span>
                                        <span className="item-desc">경기도 하남시</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">연락처(고객)</span>
                                        <span className="item-desc">010-****-****</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">보험 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">보험사</span>
                                        <span className="item-desc">삼성화재</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">접수번호</span>
                                        <span className="item-desc">2025********</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">예상과실</span>
                                        <span className="item-desc">20%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="side_item">
                                <div className="side_item-head">
                                    <span className="head-tit">청구 정보</span>
                                </div>
                                <div className="side_item-body">
                                    <div className="row-item">
                                        <span className="item-tit">청구방식</span>
                                        <span className="item-desc">보험사 기준</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">청구율</span>
                                        <span className="item-desc">60%</span>
                                    </div>
                                    <div className="row-item">
                                        <span className="item-tit">요청사항</span>
                                        <span className="item-desc">
                                            요청사항은 다음과 같습니다. 요청사항은 다음과 같습니다.요청사항은 다음과 같습니다.요청사항은
                                            다음과 같습니다.요청사항은 다음과 같습니다.요청사항은 다음과 같습니다.요청사항은 다음과
                                            같습니다.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel" onClick={handleClose}>
                        배정 받기
                    </button>
                    <button className="btn btn-primary btn-close" onClick={handleConfirm}>
                        업체 매칭중
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};

// 서명 링크 발송 안내
const SignLinkGuidePopup = ({ popupStatus, layer = true, onClose, formData, setFormData }) => {
    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup confirm-popup">
                <div className="popup-content">
                    <div className="content-title">
                        <span>서명 링크 발송 안내</span>
                    </div>
                    <div className="content-textbox">
                        <div className="item-list">
                            <div className="item">
                                <span className="item-tit">고객명</span>
                                <span className="item-desc">한규민</span>
                            </div>
                            <div className="item">
                                <span className="item-tit">연락처</span>
                                <span className="item-desc">010-2955-5388</span>
                            </div>
                        </div>
                    </div>
                    <div className="content-description">
                        <p>
                            서명 링크 발송 시 카카오톡 알림으로 전송되며, 카카오톡이 설치되어 있지 않은 경우 문자 메시지(LMS)로 전송됩니다.
                        </p>
                        <p>
                            서명자는 별도의 회원가입 없이 서명요청 받은 카카오톡 알림으로 접속해 인증 후 서명할 수 있습니다. (가급적 통화 후
                            서명 안내 부탁드립니다.)
                        </p>
                    </div>
                </div>
                <div className="popup-bottom">
                    <div className="popup-bottom">
                        <button className="btn btn-primary btn-cancel" onClick={onClose}>
                            취소
                        </button>
                        <button className="btn btn-primary btn-close" onClick={onClose}>
                            발송
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

// 계약서 등록 가이드 팝업
const ContractRegisterGuidePopup = ({ popupStatus, layer = true, onClose, formData, setFormData }) => {
    const navigate = useNavigate();

    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup contract-register-guide-popup">
                <div className="popup-content">
                    <div className="content-title">
                        <span>계약서 등록 방법</span>
                    </div>
                    <div className="way-list">
                        <div
                            className="item"
                            onClick={() => {
                                navigate(`/contract/register`);
                            }}
                        >
                            <span className="item-tit">직접 계약 등록</span>
                            {/* <span className="item-desc">
                                렌터카 또는 보험대차가 <br />
                                필요한 고객님
                            </span> */}
                        </div>

                        <div className="item" onClick={() => navigate("/order/assignment", { state: { currentTab: 1 } })}>
                            <span className="item-tit">배차 목록 선택</span>
                            {/* <span className="item-desc">
                                자동차 업계 종사자로서 <br />
                                오더를 제공할 수 있는 고객님
                            </span> */}
                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};
